/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Seat_Change_Cancel_Description_MemberInputs */



/**
* | output |
* | --- |
* | "{email} keeps their {from} seat and will not move to {to} at the renewal." |
*
* @param {Seat_Change_Cancel_Description_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_cancel_description_member = /** @type {((inputs: Seat_Change_Cancel_Description_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Cancel_Description_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} behält den ${i?.from}-Platz und wechselt zur Verlängerung nicht auf ${i?.to}.`)
	return /** @type {LocalizedString} */ (`${i?.email} keeps their ${i?.from} seat and will not move to ${i?.to} at the renewal.`)
});